import { queryOptions } from "@tanstack/react-query";
import { POLL_MS, apiGet, apiPost } from "@amber/ui";
import {
  quarantinePreviewSchema,
  releasePreviewSchema,
  releaseResultSchema,
  revisionResultSchema,
  routesResponseSchema,
} from "../../contracts/index";
import { collectionKeys } from "./keys";

/** Processing routes (IDs `processing:…`) belong to Transcription; acquisition routes to Collection. */
const routeBase = (id: string) =>
  id.startsWith("processing:") ? "/api/transcription/processing-routes" : "/api/collection/routes";

export const routesQuery = queryOptions({
  queryKey: collectionKeys.routes,
  queryFn: ({ signal }) => apiGet("/api/collection/routes", routesResponseSchema, signal),
  refetchInterval: POLL_MS,
});

export const quarantinePreviewQuery = (id: string) =>
  queryOptions({
    queryKey: collectionKeys.quarantinePreview(id),
    queryFn: ({ signal }) =>
      apiGet(`${routeBase(id)}/${encodeURIComponent(id)}/quarantine-preview`, quarantinePreviewSchema, signal),
  });

export const releasePreviewQuery = (id: string) =>
  queryOptions({
    queryKey: collectionKeys.releasePreview(id),
    queryFn: ({ signal }) =>
      apiGet(`${routeBase(id)}/${encodeURIComponent(id)}/release-preview`, releasePreviewSchema, signal),
  });

export const routeCommands = {
  quarantine: (id: string, body: { base_revision: number; reason: string }, csrf: string | null) =>
    apiPost(`${routeBase(id)}/${encodeURIComponent(id)}/quarantine`, body, revisionResultSchema, csrf),
  release: (id: string, body: { base_revision: number; reason: string }, csrf: string | null) =>
    apiPost(`${routeBase(id)}/${encodeURIComponent(id)}/release`, body, releaseResultSchema, csrf),
};
